import { useBackendApi } from './backendApi';
import { useObjectDatesMapper } from './Helper';

export interface Holiday {
  name: string;
  date: Date;
}

export function useHolidaysService() {
  const nekstApi = useBackendApi();

  const objectMapper = useObjectDatesMapper<Holiday>(['date'], []);

  const getHolidays = async (countryCode: string, year: number): Promise<Holiday[]> => {
    const result =  await nekstApi.get(`/businessdays/holidays/${countryCode}/${year}`);

    return objectMapper.mapList(result);
  };

  return {
    getHolidays,
  };
} 